import { render, staticRenderFns } from "./BroadcastSlots.vue?vue&type=template&id=5a4adfc8&scoped=true"
import script from "./BroadcastSlots.vue?vue&type=script&lang=js"
export * from "./BroadcastSlots.vue?vue&type=script&lang=js"
import style0 from "./BroadcastSlots.vue?vue&type=style&index=0&id=5a4adfc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4adfc8",
  null
  
)

export default component.exports